import { gql } from "@apollo/client";

export const INSERT_LOCATION = gql`
  mutation InsertLocationNode($object: insert_location_one_input!) {
    insert_location_node(object: $object) {
      id
      name
      parent_id
      order
      path
    }
  }
`;

export const RENAME_LOCATION = gql`
  mutation UpdateLocationNode($id: uuid!, $update: location_node_update_input) {
    update_location_node(id: $id, update: $update) {
      id
      name
      parent_id
      order
      path
    }
  }
`;

export const DELETE_LOCATION = gql`
  mutation DeleteLocationOne($id: uuid!) {
    delete_location_one(id: $id) {
      message
    }
  }
`;

export const UPDATE_LOCATION = gql`
  mutation UpdateChildLocations(
    $parent_id: uuid!
    $location_nodes: [child_location_update_input]!
  ) {
    update_child_location_nodes_multi(
      parent_id: $parent_id
      location_nodes: $location_nodes
    ) {
      message
    }
  }
`;
